import Button from "../Button"
import { useState } from "react";
import InputDropdown from '../../components/InputDropdown';

const units = [
  { label: 'Per Pound', link: '#' },
  { label: 'Per Item', link: '#' },
 
];

const ServiceDetailsForm = () => {
  const [pricePerUnit, setPricePerUnit] = useState(0);
  const [minimumSize, setMinimumSize] = useState(0);


     

//   function to increment price per unit and minimum size

const incrementPricePerUnit = (e) => {
    e.preventDefault()
    // setPricePerUnit(prevPricePerUnit => prevPricePerUnit + 1);
    setPricePerUnit((prevPricePerUnit) => parseFloat((prevPricePerUnit + 0.01).toFixed(2)));
   
  };

  const incrementMinimumSize = (e) => {
    e.preventDefault()
    // setMinimumSize(prevMinimumSize => prevMinimumSize + 1);
    setMinimumSize((prevMinimumSize) => parseFloat((prevMinimumSize + 0.01).toFixed(2)));
  }


   // Function to handle decrementing the price per unit and minimumsize
   const decrementPricePerUnit = (e) => {
    e.preventDefault()
    if (pricePerUnit > 0) {
      // setPricePerUnit(prevPricePerUnit => prevPricePerUnit - 1);
      setPricePerUnit((prevPricePerUnit) => parseFloat((prevPricePerUnit - 0.01).toFixed(2)));

    }
   
  };

  const decrementMinimumSize = (e) =>{
    e.preventDefault()
    if (minimumSize > 0) {
        // setMinimumSize(prevMinimumSize => prevMinimumSize - 1);
        setMinimumSize((prevMinimumSize) => parseFloat((prevMinimumSize - 0.01).toFixed(2)));
    }
  }

  const handleMinimumSizeChange = (e) => {
    const value = parseFloat(e.target.value);
    if (value === '') {
      setMinimumSize(0);
    } else {
      const numericValue = parseFloat(value);
      setMinimumSize(isNaN(numericValue) ? 0 : parseFloat(numericValue.toFixed(2)));
    }
  };

  const handlePricePerUnitChange = (e) => {
    const value = parseFloat(e.target.value);
    if (value === '') {
      setPricePerUnit(0);
    } else {
      const numericValue = parseFloat(value);
      setPricePerUnit(isNaN(numericValue) ? 0 : parseFloat(numericValue.toFixed(2)));
    }
  };

  return (
    <>
    <form action="" className="flex flex-col gap-10 service-form">
        <div className="flex flex-col ml-10">
            <label htmlFor="">Service name</label>
            <input type="text" placeholder='Wash N Fold' className='mt-2'/>
        </div>
        <div className="flex flex-col ml-10">
          <label htmlFor=""  className="flex flex-col ">
            Unit of measure
          <InputDropdown
          options={units}
          onSelect={(option) => console.log(option)}
          inputClass="custom-input-class mt-2"
          inputWidth="507px"
          iconMargin="530px"
          
        />
          </label>
        </div>
        <div className="flex flex-col service-detail-input-section ml-10">
            <button onClick={decrementPricePerUnit} className='decrement-btn service-detail-decrement-btn'>⌃</button>
            <label htmlFor="" className='quantity-input'>Price Per Unit
            <input
                type="number"
                value={pricePerUnit === 0 ? '' : pricePerUnit}
                onChange={handlePricePerUnitChange}
                step="0.01"
                min="1"
                className='mt-2'
                placeholder='$'
            />
            </label>
            <button onClick={incrementPricePerUnit} className='increment-btn service-detail-increment-btn'>⌃</button>
        </div>
        
        <div className=" flex flex-col service-detail-input-section ml-10">
            <button onClick={decrementMinimumSize} className='decrement-btn service-detail-decrement-btn'>⌃</button>
            <label htmlFor="" className='quantity-input'>Minimum size
            <input
                type="number"
                value={minimumSize === 0 ? '' : minimumSize}
                onChange={handleMinimumSizeChange}
                min="1"
                step="0.01"
                className='mt-2'
                placeholder='lbs'
            />
            </label>
            <button onClick={incrementMinimumSize} className='increment-btn service-detail-increment-btn'>⌃</button>
        </div>

        <div className="service-form-divider"></div>
        <section className="flex gap-4 service-form-btn-section">
            <Button style={{background: 'none', color: '#9EA3AB', fontWeight: '400'}}>Revert Changes</Button>
            <Button>Save</Button>
        </section>
    </form>
    </>
  )
}

export default ServiceDetailsForm